export default "__VITE_ASSET__e780f568__"